const globalLocation = typeof window !== `undefined` ? window.location : null;

export function getQueryParam(param, location = globalLocation) {
  if (location) {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(param);
  }
  return null;
}
